export function getPreviousQuarterAndYear(selectedYear: Date, selectedQuarter: number) {
    let year = selectedYear.getFullYear();
    let quarter = selectedQuarter - 1;

    if (quarter === 0) {
        quarter = 4;
        year--;
    }

    return {
        year,
        quarter
    };
}
